import React from 'react';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import ChangeAdminForm from '../../../components/SiteAdmin/ChangeAdminForm';
import messages from '../../../locale/messages';

class ChangeAdmin extends React.Component {

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.changeAdminPassword)}</h1>
        <ChangeAdminForm />
      </div>
    );
  }
}

export default compose(
  injectIntl
)(ChangeAdmin);
